import { createContext, useState, useEffect, useContext } from "react";
import { empty, extractDataFromArray, isEmpty, parseResponseAxios, toastMessage } from "../../utils/common";
import UserService from "../../services/user";
import config from "../../config";
import errorAndHelperText from "../../commonComponents/CommonConstants/errorAndHelperText.json"

const defaultProvider = {
    user: null,
    loading: true,
    authPopup: {},
    setAuthPopup: null,
    setUser: () => null,
    setLoading: () => Boolean,
    login: () => Promise.resolve(),
    logout: () => Promise.resolve(),
    registerUser: () => Promise.resolve(),
    isUserLoggedIn: () => Promise.resolve(),
    loginUserWithToken: () => Promise.resolve(),
}


const userContext = createContext(defaultProvider);



const UserProvider = ({ children }) => {
    //fetch user data from localStorage and set it to state
    let userData = window.localStorage.getItem("userData")
    const searchParams = new URLSearchParams(window.location.search);
    const vToken = searchParams.get("tokenV1")
    userData = JSON.parse(userData)
    if (empty(userData)) {
        userData = defaultProvider.user
        window.localStorage.setItem("userData", JSON.stringify(defaultProvider.user))
    }


    // ** States
    const [user, setUser] = useState(userData)
    const [seqValue, setSeqValue] = useState("");
    const [authPopup, setAuthPopup] = useState({ open: false, type: 'signin', callback: null })
    const [loading, setLoading] = useState(defaultProvider.loading)
    const [openArchivedSupportPopUp, setOpenArchivedSupportPopUp] = useState(false)
    const [archivedAccountResponce, setArchivedAccountResponce] = useState('')
    const [loadingSaveProfile, setLoadingSaveProfile] = useState(false)


    //Ping server for user login validation.
    const isUserLoggedIn = async () => {
        setLoading(true)
        UserService.isLoggedIn((response) => {
            setLoading(false)
            response = parseResponseAxios(response)
            if (extractDataFromArray(response, ['errorCode'], 0) === 0) {
                if (extractDataFromArray(response, ['data', 'loggedIn']) === 'Y') {
                    setUser({ ...response.data })
                    window.localStorage.setItem("userData", JSON.stringify(response.data))
                } else {
                    handleLogout()
                }
            } else {
                handleLogout()
            }
        }, () => {
            handleLogout()
        })
    }

    const loginUserWithToken = async (token) => {
        setLoading(true)

        UserService.loginUserWithToken(token, (response) => {
            setLoading(false)
            response = parseResponseAxios(response)
            if (extractDataFromArray(response, ['errorCode'], 0) === 0) {
                if (!isEmpty(extractDataFromArray(response, ['data'], {}))) {
                    setUser({ ...response.data })
                    window.localStorage.setItem("userData", JSON.stringify(response.data))
                } else {
                    handleLogout()
                }
            } else {
                handleLogout()
            }
        }, () => {
            handleLogout()
        })
    }

    const loginUserWithThirdPartyApp = async (token, callback = () => { }) => {
        setLoading(true)

        UserService.loginWithThirdPartyApp(token, (response) => {
            setLoading(false)
            response = parseResponseAxios(response)
            if (extractDataFromArray(response, ['errorCode'], 0) === 0) {
                if (!isEmpty(extractDataFromArray(response, ['data'], {}))) {
                    window.localStorage.setItem("userData", JSON.stringify(response.data))
                    UserService.loginUserInExp(
                        extractDataFromArray(response.data[0], ['email'], ''),
                        extractDataFromArray(response.data[0], ['fname'], ''),
                        extractDataFromArray(response.data[0], ['lname'], ''),
                        extractDataFromArray(response.data[0], ['profile_pic'], ''),
                        "",
                        extractDataFromArray(response.data[0], ['phone'], ''),
                        [],
                        (data) => {
                            setUser(data)
                            let currentURL = window.location.href;
                            // Decode the URL to handle encoded characters
                            currentURL = decodeURIComponent(currentURL);

                            // Check if the current URL is the login page
                            if (currentURL.includes('/login')) {
                                let redirectURL = window.location.origin;

                                // Extract the 'done' parameter if it exists
                                const doneParam = new URLSearchParams(window.location.search).get('done');

                                if (doneParam) {
                                    // If 'done' parameter exists, use it as the redirect URL
                                    redirectURL = doneParam;
                                } else if (config.module === 'lister') {
                                    // If no 'done' parameter and module is 'lister', redirect to '/landowner'
                                    redirectURL += '/landowner';
                                }

                                // Redirect to the appropriate URL
                                window.location.href = redirectURL;
                            }
                            callback()
                        },
                        (res) => {
                            // Added below logic to open archived account support pop up when sign in from google
                            if (extractDataFromArray(res, ['errorCode'], '') === 20) {

                                setOpenArchivedSupportPopUp(true)
                                setArchivedAccountResponce(extractDataFromArray(res, ['errorMsg'], 'Your account is currently inactive. Please contact support at contact@farwide.com for assistance.'))

                            }
                            handleLogout()
                        }
                    )
                } else {
                    handleLogout()
                }
            } else {
                handleLogout()
            }
        }, () => {
            handleLogout()
        })
    }



    useEffect(() => {
        if (empty(vToken)) {
            isUserLoggedIn()
        } else {
            loginUserWithToken(vToken)
        }
        // NOTE:  Don't remove this line.    Check with Abishek B before doing this
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleLogin = (email, passwd, successCallback, errorCallback) => {
        UserService.loginUser(email, passwd, (userData) => {
            // console.log("userData?.user_seq", userData?.user_seq)
            // setSeqValue(userData?.user_seq)
            localStorage.setItem("userData", JSON.stringify(userData))

            // setUser(userData) // commented this out, as setting user data from experience database, not FarWide main.

            // if (!empty(authPopup.callback)) {
            //     authPopup.callback()
            // }  // commented this out, as there's no function being added in authPop.callback(). (Not being used)


            UserService.loginUserInExp(
                extractDataFromArray(userData, ['email'], ''),
                extractDataFromArray(userData, ['fname'], ''),
                extractDataFromArray(userData, ['lname'], ''),
                extractDataFromArray(userData, ['profile_pic'], ''),
                "",
                extractDataFromArray(userData, ['phone'], ''),
                [],
                (data) => {
                    successCallback()
                    setUser(data) // Setting usersData from saveProfile api.
                },
                (res) => {
                    // Added below logic to pass reponce when archived user tries to sign in, the responce is used in sign in pop up
                    if (extractDataFromArray(res, ['errorCode'], '') === 20) {
                        errorCallback(res)
                    } else {

                    }
                    handleLogout()
                }
            )
        }, (errorCode, errorMsg = "") => {
            // if(errorCode == undefined) {
            //     toast.error("You are offline!", {
            //         theme: 'colored'
            //     })
            // } else (
            //         toast.error(errorMsg, {
            //             theme: 'colored'
            //         })
            // )
            if (errorCode == undefined) {
                toastMessage(errorAndHelperText.offline);
            } else {
                toastMessage({
                    message: errorMsg,
                    type: 'error',
                });
            }
            if (typeof errorCallback === "function") {
                errorCallback()
                // console.log("heyyyyyyyyyyy")
            }
        })
    }

    const handleLogout = (callback = null) => {
        setUser(null)
        window.localStorage.removeItem('userData')
        window.localStorage.clear()
        UserService.logoutUser()
        if (!empty(callback)) {
            callback()
        }
    }

    const handleRegister = (params, successCallback, errorCallback) => {
        UserService.registerUser(params, (userData) => {
            console.log(params)
            localStorage.setItem("userData", JSON.stringify(userData))
            setUser(userData)
            if (!empty(authPopup.callback)) {
                authPopup.callback()
            }
            UserService.loginUserInExp(
                extractDataFromArray(userData, ['email'], ''),
                extractDataFromArray(userData, ['fname'], ''),
                extractDataFromArray(userData, ['lname'], ''),
                extractDataFromArray(userData, ['profile_pic'], ''),
                "guest",
                params.phone,
                params.user_interest,
                () => {
                    successCallback()
                },
                () => {
                    handleLogout()
                }
            )
        }, (errorCode, errorMsg = "") => {
            // if(errorCode == undefined) {
            //     toast.error("You are offline!", {
            //         theme: 'colored'
            //     })
            // } else (
            //         toast.error(errorMsg, {
            //             theme: 'colored'
            //         })
            // )
            if (errorCode == undefined) {
                toastMessage(errorAndHelperText.offline);
            } else {
                toastMessage({
                    message: errorMsg,
                    type: 'error',
                });
            }
            if (typeof errorCallback === "function") {
                errorCallback()
            }
        })
    }


    useEffect(() => {// Added this to close sign in pop up when user is archived and sign in pop up opens after sign out on restricted page
        if (openArchivedSupportPopUp) {
            setAuthPopup({ ...authPopup, open: false })
        }
    }, [openArchivedSupportPopUp])

    const values = {
        user,
        loading,
        authPopup,
        setAuthPopup,
        setUser,
        setLoading,
        login: handleLogin,
        logout: handleLogout,
        registerUser: handleRegister,
        isUserLoggedIn,
        loginUserWithToken,
        seqValue, setSeqValue,
        loginUserWithThirdPartyApp,
        openArchivedSupportPopUp, setOpenArchivedSupportPopUp,
        archivedAccountResponce, setArchivedAccountResponce,
        loadingSaveProfile, setLoadingSaveProfile
    }

    return (<userContext.Provider value={values}>{children}</userContext.Provider>)
}

const UserAuth = () => {
    return useContext(userContext)
}
// export { UserProvider };
export { UserAuth, UserProvider }
